export const pt = {
  notFound:{
    ups: "Ups...",
    doesntExist: "Encontrou uma sala que não existe.",
    itsYours: "Agora é sua!",
    meanwhile: "Entretanto...",
    buttonMessage: "Voltar ao Dashboard"
  }
}